// Mock data for development when backend is not available
export const mockData = {
  products: [
    {
      id: 1,
      name: 'Wireless Headphones',
      sku: 'WH-001',
      category: 'Electronics',
      categoryId: 1,
      price: 99.99,
      cost: 60.00,
      stock: 45,
      reorderPoint: 20,
      description: 'High-quality wireless headphones with noise cancellation',
      barcode: '1234567890123',
      status: 'active',
      createdAt: '2024-01-15',
    },
    {
      id: 2,
      name: 'Bluetooth Speaker',
      sku: 'BS-002',
      category: 'Electronics',
      categoryId: 1,
      price: 79.99,
      cost: 45.00,
      stock: 8,
      reorderPoint: 15,
      description: 'Portable Bluetooth speaker with excellent sound quality',
      barcode: '1234567890124',
      status: 'active',
      createdAt: '2024-01-16',
    },
    {
      id: 3,
      name: 'USB Cable',
      sku: 'UC-003',
      category: 'Accessories',
      categoryId: 2,
      price: 12.99,
      cost: 5.00,
      stock: 150,
      reorderPoint: 50,
      description: 'High-speed USB-C cable, 6 feet',
      barcode: '1234567890125',
      status: 'active',
      createdAt: '2024-01-17',
    },
  ],

  // E-Way Bills
  ewayBills: [
    // sample structure for reference
    // {
    //   id: 1,
    //   billNo: 'EW2025/0001',
    //   docType: 'Invoice',
    //   docNo: 'INV-001',
    //   docDate: '2025-08-09',
    //   fromGstin: '22AAAAA0000A1Z5',
    //   fromTradeName: 'Sender Pvt Ltd',
    //   toGstin: '27BBBBB1111B2Z6',
    //   toTradeName: 'Receiver LLC',
    //   fromPincode: '560001',
    //   toPincode: '400001',
    //   distanceKM: 980,
    //   transporterId: 'TRANS123',
    //   vehicleNo: 'KA01AB1234',
    //   items: [
    //     { name: 'Wireless Headphones', hsn: '8518', quantity: 10, uqc: 'NOS', taxableValue: 9999.0, sgst: 0, cgst: 0, igst: 1800 },
    //   ],
    //   totalValue: 11799.0,
    //   status: 'generated',
    //   createdAt: '2025-08-09T06:00:00Z'
    // }
  ],

  locations: [
    {
      id: 1,
      name: 'Main Warehouse',
      code: 'WH-001',
      type: 'Warehouse',
      address: '123 Industrial Blvd, City, State 12345',
      capacity: 10000,
      currentStock: 8500,
      manager: 'John Smith',
      phone: '+1 (555) 123-4567',
      active: true,
    },
    {
      id: 2,
      name: 'Retail Store',
      code: 'ST-001',
      type: 'Store',
      address: '456 Main St, City, State 12345',
      capacity: 500,
      currentStock: 320,
      manager: 'Jane Doe',
      phone: '+1 (555) 234-5678',
      active: true,
    },
  ],

  quotes: [
    {
      id: 1,
      quoteNumber: 'Q-2024-001',
      customerId: 1,
      customerName: 'John Doe',
      customerEmail: 'john.doe@email.com',
      quoteDate: '2024-01-15',
      validUntil: '2024-02-15',
      total: 199.98,
      status: 'sent',
      notes: 'Bulk discount applied',
    },
    {
      id: 2,
      quoteNumber: 'Q-2024-002',
      customerId: 2,
      customerName: 'Jane Smith',
      customerEmail: 'jane.smith@company.com',
      quoteDate: '2024-01-16',
      validUntil: '2024-02-16',
      total: 79.99,
      status: 'accepted',
      notes: 'Standard pricing',
    },
  ],

  purchaseOrders: [
    {
      id: 1,
      poNumber: 'PO-2024-001',
      vendorId: 1,
      vendorName: 'Tech Supplies Inc',
      vendorEmail: 'orders@techsupplies.com',
      orderDate: '2024-01-10',
      expectedDate: '2024-01-20',
      total: 2500.00,
      status: 'confirmed',
      items: [
        { productId: 1, productName: 'Wireless Headphones', quantity: 25, unitPrice: 60.00, receivedQuantity: 0 },
        { productId: 2, productName: 'Bluetooth Speaker', quantity: 30, unitPrice: 45.00, receivedQuantity: 0 },
      ],
    },
    {
      id: 2,
      poNumber: 'PO-2024-002',
      vendorId: 2,
      vendorName: 'Cable World',
      vendorEmail: 'sales@cableworld.com',
      orderDate: '2024-01-12',
      expectedDate: '2024-01-22',
      total: 650.00,
      status: 'sent',
      items: [
        { productId: 3, productName: 'USB Cable', quantity: 130, unitPrice: 5.00, receivedQuantity: 0 },
      ],
    },
  ],

  vendors: [
    {
      id: 1,
      name: 'Tech Supplies Inc',
      company: 'Tech Supplies Inc',
      email: 'contact@techsupplies.com',
      phone: '+1 (555) 111-2222',
      category: 'Electronics',
      rating: 4.5,
      totalOrders: 15,
      totalSpent: 25000.00,
      address: '789 Supplier Ave, City, State 12345',
      contactPerson: 'Mike Johnson',
      paymentTerms: 'Net 30',
      active: true,
      notes: 'Reliable supplier with good quality products',
    },
    {
      id: 2,
      name: 'Cable World',
      company: 'Cable World LLC',
      email: 'info@cableworld.com',
      phone: '+1 (555) 333-4444',
      category: 'Accessories',
      rating: 4.2,
      totalOrders: 8,
      totalSpent: 5200.00,
      address: '321 Cable St, City, State 12345',
      contactPerson: 'Sarah Wilson',
      paymentTerms: 'Net 15',
      active: true,
      notes: 'Specializes in cables and accessories',
    },
  ],

  receivingRecords: [
    {
      id: 1,
      receivingNumber: 'REC-2024-001',
      poId: 1,
      poNumber: 'PO-2024-001',
      vendorName: 'Tech Supplies Inc',
      locationId: 1,
      locationName: 'Main Warehouse',
      receivedDate: '2024-01-18',
      totalItems: 55,
      receivedItems: 55,
      status: 'completed',
      conditions: [
        { type: 'good', count: 53 },
        { type: 'damaged', count: 2 },
      ],
      notes: '2 items had minor packaging damage',
    },
    {
      id: 2,
      receivingNumber: 'REC-2024-002',
      poId: 2,
      poNumber: 'PO-2024-002',
      vendorName: 'Cable World',
      locationId: 1,
      locationName: 'Main Warehouse',
      receivedDate: '2024-01-20',
      totalItems: 130,
      receivedItems: 100,
      status: 'partial',
      conditions: [
        { type: 'good', count: 100 },
      ],
      notes: 'Partial shipment received, remaining 30 items expected next week',
    },
  ],
};

export const mockCategories = [
  {
    id: 1,
    name: 'Electronics',
    description: 'Electronic devices and gadgets',
    parentId: null,
    parentName: null,
    productCount: 2,
    active: true
  },
  {
    id: 2,
    name: 'Accessories',
    description: 'Device accessories and peripherals',
    parentId: null,
    parentName: null,
    productCount: 1,
    active: true
  }
];

export const mockCustomers = [
  {
    id: 1,
    name: 'John Smith',
    email: 'john.smith@example.com',
    phone: '+1-555-0123',
    company: 'Tech Solutions Inc.',
    address: '123 Business Ave',
    city: 'New York',
    state: 'NY',
    zipCode: '10001',
    totalOrders: 15,
    totalSpent: 12500.00,
    lastOrderDate: '2024-01-15'
  },
  {
    id: 2,
    name: 'Sarah Johnson',
    email: 'sarah.j@company.com',
    phone: '+1-555-0456',
    company: 'Digital Corp',
    address: '456 Commerce St',
    city: 'Los Angeles',
    state: 'CA',
    zipCode: '90210',
    totalOrders: 8,
    totalSpent: 6750.00,
    lastOrderDate: '2024-01-10'
  }
];

export const mockOrders = [
  {
    id: 1001,
    customerId: 1,
    customerName: 'John Smith',
    customerEmail: 'john.smith@example.com',
    customerPhone: '+1-555-0123',
    orderDate: '2024-01-15',
    dueDate: '2024-01-20',
    status: 'processing',
    fulfillFrom: 'Eastern Warehouse',
    assignedTo: 'Ops Team',
    poNumber: 'PO-00045',
    salesRep: 'Alex Carter',
    billingAddress: {
      name: 'John Smith',
      line1: '2371 Address Blvd',
      line2: '',
      city: 'Chagrin Falls',
      state: 'OH',
      zip: '12351',
      country: 'United States'
    },
    shippingSameAsBilling: false,
    shippingAddress: {
      name: 'John Smith',
      line1: '2371 Address Blvd',
      line2: '',
      city: 'Chagrin Falls',
      state: 'OH',
      zip: '12351',
      country: 'United States'
    },
    shipByDate: '2024-01-18',
    shipOrder: true,
    paymentHistory: 'Level 1',
    taxRegion: 'California - San Francisco',
    taxRate: 0,
    invoiceLevel: 'Level 1',
    invoicedOn: '2025-08-09',
    netTerms: 'Net 30',
    dueOn: '2025-09-09',
    total: 299.97,
    balance: 299.97,
    items: [
      { productId: 1, productName: 'Wireless Headphones', quantity: 2, price: 99.99 },
      { productId: 2, productName: 'Bluetooth Speaker', quantity: 1, price: 79.99 }
    ]
  },
  {
    id: 1002,
    customerId: 2,
    customerName: 'Sarah Johnson',
    customerEmail: 'sarah.j@company.com',
    customerPhone: '+1-555-0456',
    orderDate: '2024-01-10',
    dueDate: '2024-01-15',
    status: 'shipped',
    fulfillFrom: 'Main Warehouse',
    assignedTo: 'Warehouse A',
    poNumber: 'PO-00052',
    salesRep: 'Priya Verma',
    billingAddress: {
      name: 'Sarah Johnson',
      line1: '456 Commerce St',
      line2: '',
      city: 'Los Angeles',
      state: 'CA',
      zip: '90210',
      country: 'United States'
    },
    shippingSameAsBilling: true,
    shippingAddress: null,
    shipByDate: '2024-01-12',
    shipOrder: true,
    paymentHistory: 'Paid in full',
    taxRegion: 'California - Los Angeles',
    taxRate: 9.5,
    invoiceLevel: 'Level 2',
    invoicedOn: '2024-01-11',
    netTerms: 'Prepaid',
    dueOn: '2024-01-11',
    total: 159.98,
    balance: 0,
    items: [
      { productId: 1, productName: 'Wireless Headphones', quantity: 1, price: 99.99 },
      { productId: 3, productName: 'USB Cable', quantity: 5, price: 12.99 }
    ]
  }
];

export const mockDashboardData = {
  summary: {
    totalProducts: 3,
    lowStockItems: 1,
    pendingOrders: 2,
    totalRevenue: 459.95
  },
  salesChart: [
    { date: '2024-01-01', sales: 1200 },
    { date: '2024-01-02', sales: 1450 },
    { date: '2024-01-03', sales: 1100 },
    { date: '2024-01-04', sales: 1800 },
    { date: '2024-01-05', sales: 1650 },
    { date: '2024-01-06', sales: 2100 },
    { date: '2024-01-07', sales: 1900 }
  ],
  lowStockItems: [
    {
      id: 2,
      name: 'Bluetooth Speaker',
      currentStock: 8,
      reorderPoint: 15,
      image: null
    }
  ],
  recentOrders: [
    {
      id: 1001,
      customerName: 'John Smith',
      status: 'processing',
      total: 299.97
    },
    {
      id: 1002,
      customerName: 'Sarah Johnson',
      status: 'shipped',
      total: 159.98
    }
  ]
};

export const mockReportsData = {
  sales: {
    summary: {
      totalRevenue: 459.95,
      totalOrders: 2,
      productsSold: 9,
      avgOrderValue: 229.98,
      topProducts: [
        { id: 1, name: 'Wireless Headphones', quantity: 3, revenue: 299.97, margin: 25.5 },
        { id: 2, name: 'Bluetooth Speaker', quantity: 1, revenue: 79.99, margin: 30.2 }
      ]
    },
    chartData: [
      { date: '2024-01-01', amount: 1200 },
      { date: '2024-01-02', amount: 1450 },
      { date: '2024-01-03', amount: 1100 },
      { date: '2024-01-04', amount: 1800 },
      { date: '2024-01-05', amount: 1650 }
    ]
  },
  inventory: {
    summary: {
      totalProducts: 3,
      lowStockCount: 1,
      totalValue: 2534.85,
      avgStockLevel: 67.7,
      lowStockItems: [
        { id: 2, name: 'Bluetooth Speaker', currentStock: 8, reorderPoint: 15, recommendedOrder: 25 }
      ]
    },
    chartData: [
      { category: 'Electronics', value: 53 },
      { category: 'Accessories', value: 150 }
    ]
  },
  purchase: {
    summary: {
      totalPOs: 5,
      totalPurchaseAmount: 15000,
      activeVendors: 3
    },
    chartData: [
      { vendor: 'Supplier A', value: 8000 },
      { vendor: 'Supplier B', value: 4500 },
      { vendor: 'Supplier C', value: 2500 }
    ]
  }
};
